import { Box } from "@mui/material";
import * as React from "react";
import RegistrationsDataGridPro from "../registrations/registrationList";
import { UserClaimsService } from "../../services/currentUserService/currentUserService";
import { useGetProgramManagerParticipantsQuery } from "../../services/cclTokenedEnterpriseParticipantApi";
import { ParticipantSearchResult } from "../../services/types/enterpriseParticipantApiTypes";
import { useState } from "react";
import RegistrationsClientSearchControl, { ClientRegistrationPastSearch } from "../registrations/advancedSearch/registrationClientSearch";
import { GridFilterModel } from "@mui/x-data-grid-pro";

interface ActiveRegistrationsTabPanelProps {}

const ActiveRegistrationsTabPanel: React.FC<ActiveRegistrationsTabPanelProps> = (props) => {
    const claimsService = new UserClaimsService();
    const pmImKey = claimsService.GetCurrentUserId();
    const { data: registrationData, isLoading } = useGetProgramManagerParticipantsQuery(+pmImKey, {
        skip: !pmImKey,
    });
    const [openClientSearchPanel, setOpenClientSearchPanel] = React.useState<boolean>(false);
    const [registrations, setRegistrations] = useState<any>(registrationData);
    const [storedData, setStoredData] = useState<ParticipantSearchResult[] | undefined>(registrationData);
    const [clientPastSearch, setClientPastSearch] = useState<ClientRegistrationPastSearch | undefined>(undefined);
    const [filterModel, setFilterModel] = useState<GridFilterModel | undefined>({} as GridFilterModel);

    React.useEffect(() => {
        setRegistrations(registrationData);
        setStoredData(registrationData);
    }, [registrationData]);

    const onClientSearch = (results: GridFilterModel) => {
        setFilterModel(results);
    };

    const onResetClientSearch = () => {
        setRegistrations(storedData);
        setFilterModel({} as GridFilterModel);
        setClientPastSearch(undefined);
    };

    return (
        <>
            <Box
                sx={{
                    width: 1,
                    height: 1,
                    display: "flex",
                    flexDirection: "column",
                }}
            >
                {openClientSearchPanel && (
                    <RegistrationsClientSearchControl
                        open={openClientSearchPanel}
                        onClose={() => setOpenClientSearchPanel(false)} 
                        onSearchResults={onClientSearch} 
                        data={storedData} 
                        onReset={onResetClientSearch}
                        updatePastSearch={setClientPastSearch}
                        pastSearch={clientPastSearch}                
                    />
                )}
                <RegistrationsDataGridPro
                    loading={isLoading}
                    registrations={registrations ?? []}
                    showResultBar={false}
                    resultBarText=""
                    openClientSearch={() => setOpenClientSearchPanel(true)}
                    filterModel={filterModel}
                />
            </Box>
        </>
    );
};

export default ActiveRegistrationsTabPanel;
